import React from 'react';
import SectionHeader from './SectionHeader';
import SectionWave from './SectionWave';
import HomeSectionSeam from './HomeSectionSeam';
import SkillsChaosBackground from './SkillsChaosBackground';
import SkillFlipCard from './SkillFlipCard';
import { skillGroups } from '../data/skills';

const SkillsSection = ({
  id,
  sectionClassName = 'rihen-section',
  showIntroHeader = false,
  withTopWave = false,
  withHomeSeam = false,
  withChaosBackground = false,
  introIllustration = null,
  introCentered = true,
  introEyebrow,
  introTitle,
  introTitleLine2,
  introTitleClassName = '',
  introSubtitle,
  showStackHeader = false,
  stackEyebrow = 'Stack',
  stackTitle = 'Stack et niveau de maîtrise',
  stackSubtitle = 'Je combine maîtrise technologique et vision produit pour livrer des solutions utiles et durables.',
}) => {
  return (
    <section
      className={`${sectionClassName}${withChaosBackground ? ' skills-section--chaos' : ''}`}
      id={id}
    >
      {withChaosBackground ? <SkillsChaosBackground /> : null}
      {withTopWave ? <SectionWave className="section-wave--section-start" /> : null}
      {withHomeSeam ? <HomeSectionSeam /> : null}
      <div className="rihen-site-inner">
        {showIntroHeader &&
          (introIllustration ? (
            <div className="skills-section-intro skills-section-intro--split">
              <figure className="skills-section-intro__art">{introIllustration}</figure>
              <div className="skills-section-intro__content">
                <SectionHeader
                  eyebrow={introEyebrow}
                  title={introTitle}
                  titleLine2={introTitleLine2}
                  titleClassName={introTitleClassName}
                  subtitle={introSubtitle}
                  centered={false}
                />
              </div>
            </div>
          ) : (
            <SectionHeader
              eyebrow={introEyebrow}
              title={introTitle}
              titleLine2={introTitleLine2}
              titleClassName={introTitleClassName}
              subtitle={introSubtitle}
              centered={introCentered}
              className={
                showStackHeader
                  ? 'mb-14'
                  : introCentered
                    ? 'mx-auto mb-14 max-w-2xl'
                    : 'mb-14 max-w-2xl'
              }
            />
          ))}

        {showStackHeader && (
          <SectionHeader
            eyebrow={stackEyebrow}
            title={stackTitle}
            subtitle={stackSubtitle}
            className="mb-14"
          />
        )}

        <div className="skills-flip-grid" data-reveal-stagger>
          {skillGroups.map((skillGroup, index) => (
            <div key={skillGroup.category} className="skill-flip-card-shell" data-reveal="scale">
              <SkillFlipCard skillGroup={skillGroup} index={index} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;
